module.exports = __webpack_public_path__ + "img/loading-dog.3fd19afe.gif";